<template>
  <div>
    <el-card>
      <div slot="header">Repeatwise genomic distribution in {{ info.OrgInfo.OrganismName }}</div>
      <div>
        <el-row class="echarts">
          <IEcharts theme="shine" :option="annoStackOptions" v-if="annoStackOptions !== null" />
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
  import 'echarts/theme/shine.js'
  import { store } from '../scripts/store.js'
  import IEcharts from 'vue-echarts-v3';
  import { repeatAnnoDist } from '../scripts/utils.js';
  const _ = require('lodash');

  export default {
    name: 'MainPlotBarRepeatWiseAnno',
    props: {
      info: Object,
      index: Number
    },
    components: {
      IEcharts
    },
    asyncComputed: {
      annoStackOptions: function () {
        const plotdata = this.info.AnnoInfo.RepAnno;
        const repeats = ['A', 'C', 'AC','AG', 'AT', 'CG'];
        const annodata = repeatAnnoDist(plotdata, repeats);
        const annoKeys = ['Exon', 'Intron', 'Genic', 'Intergenic']
        const promKeys = ['Promoter', 'Non-Promoter'];

        let series = [];
        annoKeys.forEach( a => {
            const d = repeats.map(o => annodata[o][a]);
            if (_.max(d) > 0){ series.push({ name: a, type: 'bar', barWidth: '30%', stack: 'Annotation', data: d }) } 
        })

        promKeys.forEach(p => {
          const d = repeats.map(o => annodata[o][p]);
          if (_.max(d) > 0){ series.push({ name: p, type: 'bar', barWidth: '30%', stack: 'Promoter', data: d }) } 
        })

        const options = {
          backgroundColor: 'white',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            backgroundColor: 'rgba(240, 240, 240, 0.8)',
            textStyle: {
              align: 'left',
              color: 'rgba(50, 50, 50, 0.8)'
            }
          },
          xAxis: { type: 'value' },
          yAxis: { type: 'category', data: repeats },
          legend: {
            show: true
          },
          resizeable: true,
          series: series,
          animation: true,
        }
        return new Promise(resolve => setTimeout(() => resolve(options), this.index * store.settings.plotUpdateDelayFactor))
      }
    }
  }
</script>